import { defaultStyles } from '../../../library';
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    jobTypeButton: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        width: '100%',
        minHeight: '80px',
        textAlign: 'center',
        textTransform: 'uppercase',
        border: '1px solid ' + defaultStyles.greyBackground,
        backgroundColor:  defaultStyles.greyBackground,
        padding: '1vmin 5vmin',
        color: defaultStyles.darkBlue,
        cursor: 'pointer',
        zIndex: 1,
        fontSize: "26px",
        alignItems: 'center',
        lineHeight: '1.2',
    },
    selected: {
        color: defaultStyles.white,
        borderColor: defaultStyles.blue,
        backgroundColor: defaultStyles.blue,
    },
    span: {
        userSelect: 'none',
        flexBasis: 'calc(100% - 90px)',
    },
    svg: {
        flexBasis: '90px',
    }
});

export default styles;
